import { HostListener, OnDestroy, Directive } from "@angular/core";
import { Observable, BehaviorSubject, of, Subscription } from "rxjs";
import { catchError } from "rxjs/operators";
import { DynamicDialogService } from "../../core/services/dynamic-dialog.service";
import { Dialog } from "../../core/models/dialog.model";
import { AuthService } from "../../services/auth.service";


@Directive()
export class CanDeactivateComponent implements OnDestroy {

    allowDeactivate = new BehaviorSubject<boolean>(true);
    confirmDialog: Dialog = undefined;

    logoutSubscription: Subscription;

    canDeactivate(): Observable<boolean> | boolean  {
        if (this.allowDeactivate.value === false && this.confirmDialog !== undefined) {
            this.confirmDialog.toggleDialog(true);
            this.dialogService.updateDialog(this.confirmDialog);
            return this.dialogService.dialogConfirmed$;
        }
        return of(true);
    }

    @HostListener('window:beforeunload', ['$event'])
    unloadNotification($event: Event) {
        if (!this.allowDeactivate.value) {
            $event.returnValue = true;
        } 
    }


    constructor(public dialogService: DynamicDialogService, public auth : AuthService) {
        this.logoutSubscription = this.auth.requireLogoutObs.pipe(
            catchError((err) => {
                console.error(err);
                return of(false);
            }
            )).subscribe(
                (force: boolean) => { this.allowDeactivate.next(force); },
                (err) => { console.error(err); }
            );        
    }

    ngOnDestroy() {
        if (this.logoutSubscription) this.logoutSubscription.unsubscribe();
    }
}